import { ChangeDetectionStrategy, Component } from '@angular/core';
import { SectionComponent } from '../../components/section/section.component';

import { AspectRatio } from '@knorr-bremse-portals/ngx-components';
import { EditorIdDirective } from '../../../app/directives/editor-id.directive';
import { PlainImageSection, imageToPicture } from '../../../app/components/plain-image/plain-image.component';
import { Section, SectionAttributes } from '../../../app/types/section';
import { iconBrakeshoeRight } from '@knorr-bremse-portals/icons';
import { IconComponent } from '@knorr-bremse-portals/ngx-components/components/icon';
import { PictureComponent } from '@knorr-bremse-portals/ngx-components/components/picture';
import { FsButtonComponent } from '../../components/fs-button/fs-button.component';

type QuoteSection = Section<
  {
    numColumns: 8 | 12;
    bgColor: 'beige' | 'blue';
    headline?: string;
    quote: string;
    person?: string;
    hideQuotes: boolean;
    rightAligned: boolean;
    image?: PlainImageSection;
  } & SectionAttributes,
  [
    'numColumns',
    'bgColor',
    'headline',
    'quote',
    'person',
    'hideQuotes',
    'image',
    'rightAligned',
  ],
  'quote'
>;

@Component({
  selector: 'section[app-quote]',
  styleUrls: ['./quote.component.scss'],
  templateUrl: './quote.component.html',
  changeDetection: ChangeDetectionStrategy.OnPush,
  standalone: true,
  imports: [
    EditorIdDirective,
    IconComponent,
    PictureComponent,
    FsButtonComponent,
],
})
export class QuoteComponent extends SectionComponent<QuoteSection> {

  protected imageToPicture = imageToPicture;
  protected aspectRatio = AspectRatio.Standard;
  protected backgroundLogo = iconBrakeshoeRight;

}


